import React from 'react';

const FitSlider = ({
  averageRating,
  fitRange,
  fitLabels,
}: {
  averageRating: number;
  fitRange?: number;
  fitLabels?: string[] | undefined;
}) => {
  if (!averageRating || averageRating < 0 || !fitRange || fitRange < 0 || !fitLabels) {
    return null;
  }
  const sliderPosition = ((averageRating - 1) * 100) / (fitRange - 1) + '%';

  return (
    <div className="fit-container d-flex flex-column">
      <label className="fit-label body">Fit:</label>
      <div className="fit-slider-wrapper d-flex flex-column align-items-center">
        <div className="fit-slider-container">
          <div className="fit-slider-bar d-flex align-items-center justify-content-between">
            <div className="fit-slider-indicator" style={{ left: sliderPosition }}></div>
          </div>
          <div className="fit-slider-ticks d-flex justify-content-between">
            {Array.from({ length: fitRange }, (_, index) => (
              <div key={index} className="fit-slider-tick"></div>
            ))}
          </div>
        </div>
        <div className="fit-slider-labels d-flex justify-content-between">
          <span className="fit-slider-label">{fitLabels[0]}</span>
          <span className="fit-slider-label">{fitLabels[fitLabels.length - 1]}</span>
        </div>
      </div>
    </div>
  );
};

export default FitSlider;
